<template>
  <v-app>
    <NavBarPublic v-if="$route.meta.public" />
    <Navbar v-else />
    <v-content>
      <router-view></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Footer from '@/components/Footer'
import Navbar from '@/components/Navbar'
import NavBarPublic from '@/components/NavBarPublic'
import { TokenService } from '@/services/storage.service'

export default {
  components: {
    Footer,
    Navbar,
    NavBarPublic
  },

  data: () => ({
    //
  }),
  computed: {
    isAuthenticated() {
      console.log(!!TokenService.getToken())
      return !!TokenService.getToken()
    }
  }
}
</script>

<style>
html {
  overflow-y: auto !important;
}
</style>
